module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v-transfer-dom-166.vue");


//////////////////
// WEBPACK FOOTER
// ./en/directives/v-transfer-dom.md
// module id = 584
// module chunks = 383